<template>
  <div>
    <DialogBase
      :visible="isOpen"
      @before-close="handleClose"
      :close-on-click-modal="false"
      width="70%"
      top="80px"
      title="Danh sách học sinh"
      panel-icon="el-icon-school"
      panel-title="Danh sách học sinh"
      panel-subtitle="Chọn lớp và tìm kiếm học sinh áp dụng tin tức này"
      @cancel="handleClose"
      @confirm="handleSaveForm"
      confirm-text="Xác nhận"
      cancel-text="Hủy bỏ"
    >
      <div class="body_dialog">
        <!-- Vùng Bộ lọc -->
        <div class="ksf-filter-bar">
          <el-row :gutter="12" type="flex" align="bottom">
            <el-col :span="8">
              <div class="ksf-filter-item">
                <span class="ksf-filter-label"><i class="el-icon-folder-opened" /> Lớp áp dụng</span>
                <el-select
                    style="width: 100%"
                    v-model="classesApply"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    @change="handleChangeFilter"
                    placeholder="Chọn lớp"
                    class="ksf-select"
                >
                  <el-option
                      v-for="(item, index) in classOptions"
                      :key="index"
                      :label="item.className"
                      :value="item.id"
                  />
                </el-select>
              </div>
            </el-col>

            <el-col :span="8" v-if="classesApply.length > 0">
              <div class="ksf-filter-item">
                <span class="ksf-filter-label"><i class="el-icon-info" /> Trạng thái học sinh</span>
                <el-select
                    style="width: 100%"
                    v-model="statusKidsApply"
                    multiple
                    filterable
                    @change="handleChangeFilter"
                    placeholder="Chọn trạng thái"
                    class="ksf-select"
                >
                  <el-option
                      v-for="(item, index) in statusList"
                      :key="index"
                      :label="item.value"
                      :value="item.key"
                  />
                </el-select>
              </div>
            </el-col>

            <el-col :span="8" v-if="classesApply.length > 0">
              <div class="ksf-filter-item">
                <span class="ksf-filter-label"><i class="el-icon-user" /> Tìm kiếm học sinh</span>
                <el-input
                    :clearable="true"
                    style="width: 100%"
                    placeholder="Nhập tên học sinh tìm kiếm..."
                    v-model="nameKids"
                    @change="handleChangeFilter"
                    @clear="handleChangeFilter"
                    class="ksf-input-search"
                >
                  <template #append>
                    <el-button
                        icon="el-icon-search"
                        @click="handleChangeFilter"
                    />
                  </template>
                </el-input>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- Vùng dữ liệu -->
        <div :class="['ksf-list-wrapper', { 'no-data': kidsDataFilter.length === 0 }]">
          <div v-if="kidsDataFilter.length > 0">
            <div class="ksf-list-header">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                Tất cả học sinh
              </el-checkbox>
            </div>
            
            <div class="ksf-scroll-area">
              <div v-for="(item) in kidsDataFilter" :key="item.idClass" class="ksf-class-group">
                <el-divider content-position="left">
                  <div class="ksf-class-divider-label">
                    <i class="el-icon-star-on"/>
                    <span class="title_group">{{ item.className }}</span>
                  </div>
                </el-divider>
                
                <el-checkbox-group v-model="idKidApply" class="ksf-checkbox-grid">
                  <el-checkbox
                      class="ksf-checkbox-item"
                      v-for="(kid) in item.students"
                      :label="kid.idKid"
                      :key="kid.idKid"
                  >
                    <span class="ksf-kid-name">{{ kid.kidsName }}</span>
                    <span :class="['ksf-status-tag', getKidStatusClass(kid.statusKids)]">
                      {{ parseKidStatusVietnamese(kid.statusKids) }}
                    </span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>

          <div v-else class="ksf-empty-state">
            <i class="el-icon-warning"/>
            <span>Vui lòng chọn lớp để hiển thị danh sách học sinh</span>
          </div>
        </div>
      </div>
    </DialogBase>
  </div>
</template>

<script>
import SurveyForm from "@/services/SurveyForm";
import DialogBase from "@/components/DialogBase.vue";
import {mapState} from "vuex";
import parseInfoKidVietnameseMixin from "@/global/mixinKid/parseInfoKidVietnamese.mixin";

export default {
  components: { DialogBase },
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    },
    scope:{
      type: String,
      default: () => "SCHOOL"
    }
  },
  computed: {
    ...mapState('classStore', ['classListCommon']),
    classOptions() {
      if (this.$props.scope === "SCHOOL") {
        return this.classListCommon;
      } else {
        const uniqueClasses = [];
        const map = new Map();
        if (this.kidsInSchool && this.kidsInSchool.length > 0) {
          for (const kid of this.kidsInSchool) {
            if (kid.idClass && !map.has(kid.idClass)) {
              map.set(kid.idClass, true);
              uniqueClasses.push({
                id: kid.idClass,
                className: kid.className
              });
            }
          }
        }
        return uniqueClasses;
      }
    }
  },
  data() {
    return {
      kidsInSchool: [],
      kidsDataFilter: [],
      classesApply: [],
      nameKids: "",
      statusKidsApply: ["STUDYING"],
      statusList: [
        { key: "STUDYING", value: "Đang học" },
        { key: "STUDY_WAIT", value: "Chờ học" },
        { key: "RESERVE", value: "Bảo lưu" },
        { key: "LEAVE_SCHOOL", value: "Nghỉ học" },
        { key: "OUT_SCHOOL", value: "Ra trường" }
      ],
      idKidApply: [],
      checkAll: false,
      isIndeterminate: false
    }
  },

  watch: {
    isOpen(newVal) {
      if (newVal) {
        if (this.$props.scope === "SCHOOL") {
          this.fetchKidsInSchool();
        } else if (this.$props.scope === "CLASS") {
          this.fetchKidsInClass();
        }
      }
    },

    classesApply(newVal, oldVal) {
      if (newVal.length < oldVal.length) {
        this.handleChangeKidsRemoveApply(newVal, oldVal);
      }
    },

    idKidApply(newVal) {
      if (newVal.length === this.parseDataFilterId(this.kidsDataFilter).length && this.parseDataFilterId(this.kidsDataFilter).length > 0) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else if (newVal.length === 0) {
        this.checkAll = false;
        this.isIndeterminate = false;
      } else if (newVal.length < this.parseDataFilterId(this.kidsDataFilter).length) {
        this.checkAll = false;
        this.isIndeterminate = true;
      }
    },

    kidsDataFilter(newVal) {
      if (this.parseDataFilterId(newVal).length > 0 && this.parseDataFilterId(newVal).length === this.idKidApply.length) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else if (this.idKidApply.length > 0 && this.parseDataFilterId(newVal).length > this.idKidApply.length) {
        this.checkAll = false;
        this.isIndeterminate = true;
      }

      this.handleChangeCheckApply();
    }
  },

  mixins: [
    parseInfoKidVietnameseMixin
  ],

  created() {
    if (this.$props.scope === "SCHOOL") {
      this.fetchKidsInSchool();
    } else if (this.$props.scope === "CLASS") {
      this.fetchKidsInClass();
    }
  },
  methods: {
    handleClose() {
      this.$emit("closeDialog");
      this.resetData();
    },

    handleChangeCheckApply() {
      const idKidApply = this.idKidApply;
      const dataFilter = this.parseDataFilterId(this.kidsDataFilter);

      if (idKidApply.length > 0 && dataFilter.length > 0 && idKidApply.length > dataFilter.length) {
        const studentIds = dataFilter.map(student => student.idKid);

        this.idKidApply = idKidApply.filter(id => studentIds.includes(id));
      }
    },

    fetchKidsInSchool() {
      SurveyForm.getAllKidsSchool()
          .then((res) => {
            this.kidsInSchool = res.data.data;
          })
          .catch((err) => {
            console.log(err);
          })
    },
    fetchKidsInClass() {
      SurveyForm.getAllKidsClass()
          .then((res) => {
            this.kidsInSchool = res.data.data;
          })
          .catch((err) => {
            console.log(err);
          })
    },

    handleCheckAllChange(val) {
      this.idKidApply = val ? this.getDataIdKids(this.parseDataFilterId(this.kidsDataFilter)) : [];
      this.isIndeterminate = false;
    },

    parseDataFilterId(dataFilter) {
      return dataFilter.flatMap(classItem => classItem.students);
    },

    getDataIdKids(kids) {
      const idKids = [];

      kids.map(kid => idKids.push(kid.idKid));

      return idKids;
    },

    getDataKidsApply(idKids) {
      return this.kidsInSchool.filter(kid => idKids.includes(kid.idKid));
    },

    handleChangeFilter() {
      const idClassList = this.classesApply;
      const name = this.nameKids;
      const statuses = this.statusKidsApply;
      const kids = this.kidsInSchool;
      const result = [];

      idClassList.forEach((id) => {
        kids.forEach((kid) => {
          if (kid.idClass === id) {
            const matchName = name === "" || this.removeVietnameseTones(kid.kidsName).includes(this.removeVietnameseTones(name));
            const matchStatus = statuses.length === 0 || statuses.includes(kid.statusKids);
            if (matchName && matchStatus) {
              result.push(kid);
            }
          }
        });
      });

      this.kidsDataFilter = this.groupKidsByIdClass(result);
    },

    groupKidsByIdClass(kids) {
      const groupedObj = {};

      kids.forEach(item => {
        if (!groupedObj[item.idClass]) {
          groupedObj[item.idClass] = {
            idClass: item.idClass,
            className: item.className,
            students: []
          };
        }
        groupedObj[item.idClass].students.push({
          idKid: item.idKid,
          kidsName: item.kidsName,
          statusKids: item.statusKids,
          idClass: item.idClass,
          className: item.className
        });
      });

      return Object.values(groupedObj);
    },

    removeVietnameseTones(str) {
      return str
          .normalize("NFD") // Tách các dấu tiếng Việt thành ký tự riêng
          .replace(/[\u0300-\u036f]/g, "") // Loại bỏ dấu
          .replace(/đ/g, "d")
          .replace(/Đ/g, "D")
          .toLowerCase(); // Chuyển về chữ thường
    },

    handleSaveForm() {
      console.log(this.idKidApply)
      const data = {
        classesApply: this.idKidApply.length === 0 ? [] : this.classesApply,
        kidsApply: this.getDataKidsApply(this.idKidApply),
      }

      console.log("data", data);

      this.$emit('confirmData', data);
      this.resetData();
    },

    initialDataApply(classes, kids) {
      this.classesApply = classes;
      this.idKidApply = kids;
      this.handleChangeFilter();
    },

    resetData() {
      this.kidsDataFilter = [];
      this.classesApply = [];
      this.nameKids = "";
      this.statusKidsApply = [];
      this.checkAll = false;
      this.isIndeterminate = false;
    },

    handleChangeKidsRemoveApply(newVal, oldVal) {
      const idRemovedValues = oldVal.filter(value => !newVal.includes(value));

      this.idKidApply = this.idKidApply.filter(kid => kid.idClass !== idRemovedValues[0])
    },

    getKidStatusClass(status) {
      switch (status) {
        case "STUDYING":
          return "ksf-status-tag--studying";
        case "STUDY_WAIT":
          return "ksf-status-tag--study-wait";
        case "RESERVE":
          return "ksf-status-tag--reserve";
        case "LEAVE_SCHOOL":
          return "ksf-status-tag--leave-school";
        case "OUT_SCHOOL":
          return "ksf-status-tag--out-school";
        default:
          return "";
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.body_dialog {
  padding: 4px 0;
}

/* ─── Filter Bar ───────────────────────────────────── */
.ksf-filter-bar {
  margin-bottom: 16px;
  background: #ffffff;
  padding: 4px 0;
}

.ksf-filter-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ksf-filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  
  i {
    color: #2563eb;
    font-size: 14px;
  }
}

/* Bo góc cho input và select */
/deep/ .ksf-select .el-input__inner,
/deep/ .ksf-input-search .el-input__inner {
  border-radius: 10px;
  background: #f8fafc;
  border-color: #e2e8f0;
  transition: all 0.2s ease;
  height: 40px;
  line-height: 40px;
}

/deep/ .ksf-select .el-input__inner:focus,
/deep/ .ksf-input-search .el-input__inner:focus {
  border-color: #2563eb;
  background: #ffffff;
}

/deep/ .ksf-select .el-select__tags {
  padding-left: 6px;
}

/deep/ .ksf-input-search .el-input-group__append {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  background: #f1f5f9;
  border-color: #e2e8f0;
  padding: 0 16px;
  
  .el-button {
    margin: -10px -16px;
    border-radius: 0 10px 10px 0;
    color: #475569;
    
    &:hover {
      color: #2563eb;
    }
  }
}

/* ─── List Wrapper ─────────────────────────────────── */
.ksf-list-wrapper {
  min-height: 380px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 14px;
  padding: 16px 20px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  
  &.no-data {
    justify-content: center;
    align-items: center;
  }
}

.ksf-list-header {
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
  
  /deep/ .el-checkbox__inner {
    border-radius: 4px;
    width: 18px;
    height: 18px;
    border-color: #cbd5e1;
  }
  
  /deep/ .el-checkbox__label {
    font-weight: 700;
    color: #1e293b;
    font-size: 14px;
  }
}

.ksf-scroll-area {
  height: 380px;
  overflow-y: auto;
  padding-right: 4px;
  
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
    
    &:hover {
      background: #94a3b8;
    }
  }
}

.ksf-class-group {
  margin-bottom: 20px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.ksf-class-divider-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  
  i {
    color: #eab308;
    font-size: 16px;
  }
  
  .title_group {
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
  }
}

/deep/ .el-divider--horizontal {
  margin: 16px 0 12px;
  background-color: #e2e8f0;
}

/* ─── Checkbox Grid ────────────────────────────────── */
.ksf-checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 4px 0;
}

/deep/ .ksf-checkbox-item {
  margin: 0 !important;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  
  &:hover {
    border-color: #2563eb;
    background: #f0f6ff;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(37, 99, 235, 0.05);
  }
  
  .el-checkbox__inner {
    border-radius: 4px;
    width: 18px;
    height: 18px;
    border-color: #cbd5e1;
  }
  
  &.is-checked {
    border-color: #2563eb;
    background: #eff6ff;
    
    .el-checkbox__inner {
      background-color: #2563eb;
      border-color: #2563eb;
    }
  }
  
  .el-checkbox__label {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: 13.5px;
    padding-left: 10px;
    white-space: normal;
  }
}

.ksf-kid-name {
  font-weight: 600;
  color: #1e293b;
}

/* Status Badges */
.ksf-status-tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  margin-left: 6px;
  border: 1px solid transparent;
}

.ksf-status-tag--studying {
  background: #ecfdf5;
  color: #059669;
  border-color: #a7f3d0;
}

.ksf-status-tag--study-wait {
  background: #eff6ff;
  color: #2563eb;
  border-color: #dbeafe;
}

.ksf-status-tag--reserve {
  background: #fffbeb;
  color: #d97706;
  border-color: #fde68a;
}

.ksf-status-tag--leave-school {
  background: #fef2f2;
  color: #dc2626;
  border-color: #fecaca;
}

.ksf-status-tag--out-school {
  background: #f8fafc;
  color: #64748b;
  border-color: #e2e8f0;
}

/* ─── Empty State ──────────────────────────────────── */
.ksf-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  
  i {
    font-size: 32px;
    color: #3b82f6;
  }
}
</style>